const COLOR_CLASSES = {
  violet: {
    focus: 'focus:border-violet-500 focus:ring-2 focus:ring-violet-200',
    button: 'border-violet-300 text-violet-600 hover:bg-violet-50',
  },
  blue: {
    focus: 'focus:border-blue-500 focus:ring-2 focus:ring-blue-200',
    button: 'border-blue-300 text-blue-600 hover:bg-blue-50',
  },
  purple: {
    focus: 'focus:border-purple-500 focus:ring-2 focus:ring-purple-200',
    button: 'border-purple-300 text-purple-600 hover:bg-purple-50',
  },
  indigo: {
    focus: 'focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200',
    button: 'border-indigo-300 text-indigo-600 hover:bg-indigo-50',
  },
  emerald: {
    focus: 'focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200',
    button: 'border-emerald-300 text-emerald-600 hover:bg-emerald-50',
  },
  red: {
    focus: 'focus:border-red-500 focus:ring-2 focus:ring-red-200',
    button: 'border-red-300 text-red-600 hover:bg-red-50',
  },
}

export default function FilterSelect({ label, value, options, onChange, colorScheme = 'violet' }) {
  const colors = COLOR_CLASSES[colorScheme] || COLOR_CLASSES.violet
  return (
    <label className="flex flex-col gap-1 text-sm">
      <span className="font-medium text-gray-700">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none transition ${colors.focus}`}
      >
        {options.map((opt) => (
          <option key={typeof opt === 'object' ? opt.value : opt} value={typeof opt === 'object' ? opt.value : opt}>
            {typeof opt === 'object' ? opt.label : opt}
          </option>
        ))}
      </select>
    </label>
  )
}
